import React from "react";
import { Link, NavLink } from "react-router-dom";

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.clickedMenuItem = this.clickedMenuItem.bind(this);
    this.state = {
      open: window.innerWidth < 992 && window.innerWidth > 1350,
    };
  }

  toggleMenu() {
    this.setState((state) => {
      return {
        open: !state.open,
      };
    });
  }

  clickedMenuItem() {
    if (window.innerWidth < 992) {
      this.setState((state) => {
        return {
          open: false,
        };
      });
    }
  }

  render() {
    return (
      <nav id="menu">
        <div id="nav-icon" className={this.state.open ? "open" : ""} onClick={(e) => this.toggleMenu()}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul className={"pages " + (this.state.open ? "" : "collapsed")}>
          {this.props.pages.map(
            function (page, index) {
              return (
                <li className={(this.state.open ? "" : "collapsed")} onClick={this.clickedMenuItem} key={`menu-item-${index}`}>
                  <NavLink className={({ isActive }) => isActive ? "active" : "" } to={page.path}>{page.name}</NavLink>
                </li>
              );
            }.bind(this)
          )}
        </ul>
      </nav>
    );
  }
}

class Logo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id="logo">
        <div className="d-none d-lg-inline-block">
          <Link to="/" className="logo-title">
            <h1>Gehirnpfade</h1>
            <h2 className="sub">Entwickle Dich weiter</h2>
          </Link>
        </div>
        <div className="social-bar">
          <a href="https://www.instagram.com/heidejanowitz/" className="fab fa-instagram fa-fw fa-2x"></a>
          <a href="https://heide-janowitz.de/" className="fas fa-blog fa-fw fa-2x"></a>
          <a href="https://www.youtube.com/user/Coachingprofi" className="fab fa-youtube fa-fw fa-2x"></a>
        </div>
      </div>
    );
  }
}

export default class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id="header">
        <Menu pages={this.props.pages} />
        <Logo />
      </div>
    );
  }
}
